// information took from property applicationKey
export const PRODUCT_LINE_STATUS = {
  Pending: 'Pending',
  Incomplete: 'Incomplete',
  Denied: 'Denied',
  NonAdmit: 'NonAdmit',
  Non_Admit: 'Non-Admit',
  Approved: 'Approved',
  Cancelled: 'Cancelled',
  Dismissed: 'Dismissed',
};

// information took from property applicationKey
export const PRODUCT_LINE_STATUS_REASON = {
  AdditionalInformation1stOutreach: 'AdditionalInformation1stOutreach',
  AdditionalInformation2ndOutreach: 'AdditionalInformation2ndOutreach',
  Approval: 'Approval',
  Resubmit: 'Resubmit',
  ProviderOutcome: 'ProviderOutcome',
  IntentToDeny: 'IntentToDeny',
  ZZLine: 'ZZLine',
  Draft: 'Draft',
  ClinicalReview: 'ClinicalReview',
  ClinicalQuestionnaire: 'ClinicalQuestionnaire',
  EscalatedReviewRequest: 'EscalatedReviewRequest',
  EscalatedReviewRequest2ndReview: 'EscalatedReviewRequest2ndReview',
  EscalatedReviewRequestNonCovered: 'EscalatedReviewRequestNonCovered',
  EscalatedReviewRequestPhysicianCode: 'EscalatedReviewRequestPhysicianCode',
  EscalatedReviewRequestPlaceofService: 'EscalatedReviewRequestPlaceofService',
  PeerToPeer: 'PeerToPeer',
  PendingSCA: 'PendingSCA',
  Staffing: 'Staffing',
  AORPOA: 'AORPOA',
  ReturnCall: 'ReturnCall',
  MDOrders1stOutreach: 'MDOrders1stOutreach',
  MDOrders2ndOutreach: 'MDOrders2ndOutreach',
  RequestMeetsMedicalNecessity: 'RequestMeetsMedicalNecessity',
  AppealsAdministrativeApproval: 'AppealsAdministrativeApproval',
  CoveredService: 'CoveredService',
  DisasterDeclaration: 'DisasterDeclaration',
  HealthPlanAppealOverturn: 'HealthPlanAppealOverturn',
  PlanDirectedCare: 'PlanDirectedCare',
  RetroApprovalAdministrative: 'RetroApprovalAdministrative',
  RetroApprovalMedicalNecessity: 'RetroApprovalMedicalNecessity',
  UMNotRequired: 'UMNotRequired',
  DMEPOSProviderAgreement: 'DMEPOSProviderAgreement',
  LackOfMedicalNecessity: 'LackOfMedicalNecessity',
  NoMDOrder: 'NoMDOrder',
  RequestNotTimely: 'RequestNotTimely',
  NotACoveredService: 'NotACoveredService',
  OutOfNetwork: 'OutOfNetwork',
  AppealUpheld: 'AppealUpheld',
  AppealPartialDenial: 'AppealPartialDenial',
  Duplicate: 'Duplicate',
  Error: 'Error',
  ReopeningClericalError: 'ReopeningClericalError',
  ReopeningMedicalNecessity: 'ReopeningMedicalNecessity',
  ReopeningCriteriaNotMet: 'ReopeningCriteriaNotMet',
  Retro: 'Retro',
  OutOfArea: 'OutOfArea',
  InvalidRequestNotAHealthPlanMember: 'InvalidRequestNotAHealthPlanMember',
  InvalidRequestServicePlannedToOccurAfterEnrollmentEnds: 'InvalidRequestServicePlannedToOccurAfterEnrollmentEnds',
  InvalidRequestServicePlannedToOccurBeforeEnrollment: 'InvalidRequestServicePlannedToOccurBeforeEnrollment',
  InvalidRequestServicePlannedToOccurPriorToStartDateOfDelegation: 'InvalidRequestServicePlannedToOccurPriorToStartDateOfDelegation',
  InvalidRequestNoMDOrders: 'InvalidRequestNoMDOrders',
  InvalidRequestUnauthorizedRequestorNotAORPOA: 'InvalidRequestUnauthorizedRequestorNotAORPOA',
  MemberDeceased: 'MemberDeceased',
  WithdrawnByMember: 'WithdrawnByMember',
  WithdrawnByProvider: 'WithdrawnByProvider',
  WithdrawnByRepresentative: 'WithdrawnByRepresentative',
  AdmittedToFacility: 'AdmittedToFacility',
  AdmittedToHospice: 'AdmittedToHospice',
  AlreadyHasEquipment: 'AlreadyHasEquipment',
  MemberRefused: 'MemberRefused',
  MemberNotDischarged: 'MemberNotDischarged',
  UnableToContactMember: 'UnableToContactMember',
  Other: 'Other',
  Routine: 'Routine',
  Urgent: 'Urgent',
  Downgraded: 'Downgraded',
  Upgraded: 'Upgraded'
};

export const PRODUCT_LINE_STATUS_REASON_DESCRIPTION = {
  IntentToDeny: 'Intent to Deny'
}
